import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import {TextOperatorType} from "../../../../../../models/text-operator";
import {BaseFieldDeterminantComponent} from "./base-field-determinant.component";

@Component({
  selector: "file-determinant",
  templateUrl: "./file-determinant.component.html",
  styles: [],
})
export class FileDeterminantComponent extends BaseFieldDeterminantComponent {

  public operators: string[];
  @Input() public isTargetComponent: boolean;
  @Input() public operator: TextOperatorType;
  @Input() public fields: any [] = [];
  @Output() public operatorResponse = new EventEmitter();

  public ngOnInit() {
    this.operators = Object.keys(TextOperatorType);
    super.ngOnInit();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.operator && changes.operator.currentValue) {
      this.operator = changes.operator.currentValue;
    }
    if (changes.fields && changes.fields.currentValue) {
      this.fields = this.fields.filter((field) => (field.type === "file"));
    }
    super.ngOnChanges(changes);
  }

  public operatorValueChanged() {
    this.operatorResponse.emit(this.operator);
  }

}
